import { render, staticRenderFns } from "./AnswerEmail.vue?vue&type=template&id=766efaf8&"
import script from "./AnswerEmail.vue?vue&type=script&lang=js&"
export * from "./AnswerEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports